"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
/**
 * S shape svg connector
 * @param startPoint
 * @param endPoint
 * @param stroke
 * @param strokeWidth
 * @param startArrow
 * @param endArrow
 * @param arrowSize
 */
function SConnector(props) {
    var direction = props.direction, stroke = props.stroke, strokeWidth = props.strokeWidth, startArrow = props.startArrow, endArrow = props.endArrow, startPoint = props.startPoint, endPoint = props.endPoint, arrowSize = props.arrowSize, rest = __rest(props, ["direction", "stroke", "strokeWidth", "startArrow", "endArrow", "startPoint", "endPoint", "arrowSize"]);
    var distanceX = props.endPoint.x - props.startPoint.x;
    var distanceY = props.endPoint.y - props.startPoint.y;
    var grids = 4;
    var stepX = distanceX / grids;
    var stepY = distanceY / grids;
    return (react_1.default.createElement("svg", { width: "100%", height: "100%", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", __assign({}, rest, { d: "M\n            " + props.startPoint.x + " " + props.startPoint.y + " \n            q \n            " + (stepX * grids) / 2 + " 0 \n            " + (stepX * grids) / 2 + " " + (stepY * grids) / 2 + "\n            q \n            0 " + (stepY * grids) / 2 + " \n            " + (stepX * grids) / 2 + " " + (stepY * grids) / 2 + "\n        ", stroke: props.stroke || "orange", strokeWidth: props.strokeWidth || 3, fill: "transparent" }))));
}
exports.default = SConnector;
